import { Body, Box, Button, Icon, Sheet, VStack } from '@hover/blueprint';
import type { IconProp } from '@hover/icons';
import React from 'react';

import { MenuLinkDivider } from 'src/modules/homeownerApp/components/MenuLink';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

export type MenuOption = {
  title: string;
  color?: string;
  onClick: () => void;
  icon: IconProp;
};

type MoreActioMenuProps = {
  options: MenuOption[];
  onCancel: () => void;
};

export const MoreActionMenu = ({ options, onCancel }: MoreActioMenuProps) => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);

  return (
    <Sheet.Contents contentKey="more-actions">
      <VStack
        marginBottom={{ base: 300, tablet: 0 }}
        marginX={{ tablet: 500 }}
        marginY={{ tablet: 400 }}
      >
        {options.map(({ title, color, onClick, icon }, index) => (
          <Box key={title} width="100%">
            <Box
              color={color}
              cursor="pointer"
              flexDirection="column"
              width="100%"
            >
              {index !== 0 && (
                <MenuLinkDivider key={`divider-${title}`} mb={200} />
              )}
              <Box
                alignItems="center"
                justifyContent="space-between"
                key={title}
                onClick={onClick}
                width="100%"
              >
                <Body color={color} isBold size={500}>
                  {title}
                </Body>
                <Icon icon={icon} strokeWidth="2.2px" />
              </Box>
            </Box>
          </Box>
        ))}
        <Box display={{ tablet: 'none' }} paddingTop={300} width="100%">
          <Button onClick={onCancel} variant="secondary" width="100%">
            {t('projects.edit.cancel')}
          </Button>
        </Box>
      </VStack>
    </Sheet.Contents>
  );
};
